import { useCallback, useState } from "react";

const STORAGE_KEY = "kc_paid_actions";

function readPaid() {
  try {
    return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

// Each premium action (e.g. "match", "chart") is unlocked once per browser
// session after a verified payment, so a user isn't charged again for
// re-running the same report while they're still on the page.
export function usePaidActions() {
  const [paid, setPaid] = useState(readPaid);

  const isPaid = useCallback((action) => !!paid[action], [paid]);

  const markPaid = useCallback((action) => {
    setPaid((prev) => {
      const next = { ...prev, [action]: true };
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  }, []);

  return { isPaid, markPaid };
}
